export default __webpack_public_path__ + "static/media/explore-active.e1b4a5df.svg";